import { CharacterCount } from "@/components/Input/CharacterCount"
import { ErrorText } from "@/components/Input/ErrorText"
import { Label } from "@/components/Input/Label"
import { Field } from "@/components/Input/Field"

export const Input = {
	CharacterCount,
	ErrorText,
	Label,
	Field
}